import script from "./workspacemodulesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./workspacemodulesList.vue?vue&type=script&lang=ts&setup=true"

import "./workspacemodulesList.vue?vue&type=style&index=0&id=716e2750&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716e2750"]])

export default __exports__